/** URLSearchParams already decodes once. Return the original local path unchanged. */
export function localAuthRedirect(search: string | URLSearchParams): string | undefined {
  const target = new URLSearchParams(search).get('redirect');
  if (!target) return undefined;
  try {
    const decoded = decodeURIComponent(target);
    if (!decoded.startsWith('/') || decoded.startsWith('//') || /[\\\u0000-\u0020\u007f]/.test(decoded.split('?')[0])) return undefined;
    const path = new URL(decoded, 'https://blueticks.invalid').pathname;
    if (/^\/(?:clear-)?(?:login|signup|forgot-password)\/?$/i.test(path)) return undefined;
    return target;
  } catch { return undefined; }
}

export function authNavigationTarget(search: string | URLSearchParams, fallback: string): string {
  return localAuthRedirect(search) ?? fallback;
}

export function preserveAuthRedirect(path: string, search: string): string {
  const redirect = localAuthRedirect(search);
  return redirect ? `${path}?${new URLSearchParams({ redirect })}` : path;
}
